const TodoQueryFields = [
    {
        name: '#',
        code: '_seq_',
        column: true,
        sortable: false,
        defaultFilter: false,
        width: 70
    },
    {
        name: '标题',
        code: 'title',
        column: true,
        sortable: false,
        defaultFilter: true,
        listFilter: true
    },
    {
        name: '当前审批人',
        code: 'currentApprovers',
        column: true,
        sortable: false,
        align: 'left',
        width: 200
    },
    {
        name: '发起人',
        code: 'submitterName',
        column: true,
        sortable: false,
        align: 'center',
        width: 150
    },
    {
        name: '发起部门',
        code: 'submitterDept',
        column: true,
        sortable: false,
        align: 'left',
        width: 200
    },
    {
        name: '发起日期',
        code: 'submitDate',
        column: true,
        sortable: false,
        align: 'center',
        width: 200
    }
];
export default TodoQueryFields;
